import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { sparxsEditorBlueprintFetchedHydrated } from "@/features/sparxsEditor/store/domainActions";

export type BlueprintLoadBoundaryState = null | {
  fileName: string;
  message: string;
  notFound?: boolean;
};

const initialState = null as BlueprintLoadBoundaryState;

const blueprintLoadBoundarySlice = createSlice({
  name: "blueprintLoadBoundary",
  initialState,
  reducers: {
    sparxsEditorBlueprintLoadBoundaryFailed: (
      _state,
      action: PayloadAction<{
        fileName: string;
        message: string;
        notFound?: boolean;
      }>,
    ): BlueprintLoadBoundaryState => ({
      fileName: action.payload.fileName,
      message: action.payload.message,
      ...(action.payload.notFound === true ? { notFound: true as const } : {}),
    }),
    clearSparxsEditorBlueprintLoadBoundary: (): BlueprintLoadBoundaryState =>
      null,
  },
  extraReducers: (builder) => {
    builder.addCase(sparxsEditorBlueprintFetchedHydrated, (state, action) => {
      if (state == null) {
        return state;
      }
      return state.fileName === action.payload.fileName ? null : state;
    });
  },
});

export const {
  sparxsEditorBlueprintLoadBoundaryFailed,
  clearSparxsEditorBlueprintLoadBoundary,
} = blueprintLoadBoundarySlice.actions;

export default blueprintLoadBoundarySlice.reducer;
